const colors = {
	lightGreen: '#B0E3D9',
	green: '#17ABA6',
	white: '#ffffff',
	darkGrey: '#777777',
	grey: '#B5B5B5',
	black: '#252525',
	purple: '#402661',
	coral: '#F77566',
	pink: '#FFD1CF',
	lightWhite: '#FAFAFA',
};

const cssVariables = {
	/* FORM */
	form_p1: 'var(--h2)',
	form_p2: 'var(--h2)',
	form_p3: 'var(--h3)',
	form_p4: 'var(--h4)',
	form_p5: 'var(--p)',

	/* ACCOUNT */
	account_h1: 'var(--h1L)',
	account_h2: 'var(--h1)',
	account_h3: 'var(--h2L)',
	account_h4: 'var(--h2)',
	account_h5: 'var(--h3)',
	account_h6: 'var(--h4)',

	account_p1: 'var(--h2)',
	account_p2: 'var(--h3)',
	account_p3: 'var(--h4)',
	account_p4: 'var(--h5)',
	account_p5: 'var(--p)',
};

export default {
	colors,
	cssVariables,

	mediaQuery: {
		DesktopSizeL: '1920px',
		DesktopSizeS: '1440px',
		DesktopSizeXS: '1280px',
		TabletSize: '1024px',
		TabletSizeS: '768px',

		DesktopSizeLMin: '1919px',
		DesktopSizeSMin: '1439px',
		DesktopSizeXSMin: '1279px',
		TabletSizeMin: '1023px',
		TabletSizeSMin: '767px',

		desktopSizeXL: '2560px',
		desktopSizeL: '1920px',
		desktopSizeM: '1536px',
		desktopSizeS: '1366px',
		tabletSize: '1280px',
		tabletSizeS: '768px',

		desktopSizeXLMin: '2559px',
		desktopSizeLMin: '1919px',
		desktopSizeMMin: '1535px',
		desktopSizeSMin: '1365px',
		tabletSizeMin: '1279px',
		tabletSizeSMin: '767px',
	},

	form: {
		colors: {
			emptyTextColor: colors.black,

			labelColor: colors.black,
			labelHoverColor: colors.black,
			labelFocusColor: colors.black,
			labelActiveColor: colors.black,
			labelErrorColor: colors.coral,
			labelDisabledColor: colors.darkGrey,
			labelErrorColor: colors.black,

			inputColor: colors.black,
			inputBgColor: colors.white,
			inputFocusColor: colors.black,

			inputPlaceholderColor: colors.darkGrey,
			inputPlaceholderHoverColor: colors.darkGrey,
			inputPlaceholderFocusColor: colors.black,

			inputPlaceholderErrorColor: colors.coral,
			inputErrorColor: colors.coral,
			inputErrorBgColor: 'transparent',
			inputBorderErrorColor: colors.coral,

			inputBorderColor: colors.grey,
			inputDisabledBgColor: colors.lightWhite,
			inputDisabledColor: colors.darkGrey,
			inputBorderDisabledColor: colors.grey,
			inputBorderFocusColor: colors.grey,
			inputBorderHoverColor: colors.grey,
			inputBorderActiveColor: colors.grey,
			inputFocusBgColor: colors.white,
			inputHoverBgColor: colors.white,

			errorMessageColor: colors.coral,
			errorMessageBorderColor: colors.coral,
			errorMessageBgColor: 'transparent',

			selectColor: colors.black,
			selectBorderColor: colors.black,
			selectBgColor: colors.white,
			selectBorderFocusColor: colors.grey,
			selectPlaceholderColor: colors.darkGrey,
			selectPlaceholderFocusColor: colors.black,
			selectDisabledBgColor: colors.lightWhite,
			selectBorderDisabledColor: colors.lightWhite,
			selectOptionColor: colors.darkGrey,
			selectOptionActiveColor: colors.black,
			selectOptionBgColor: colors.white,
			selectOptionFocusBgColor: colors.lightWhite,

			selectOptionHoverColor: colors.black,
			selectOptionFocusColor: colors.black,

			selectFocusBgColor: colors.white,
			selectHoverBgColor: colors.white,
			selectActiveBgColor: colors.white,
			selectPlaceholderHoverColor: colors.darkGrey,
			selectBorderColor: colors.grey,
			selectBorderHoverColor: colors.grey,
			selectOptionHoverBgColor: 'transparent',
			selectOptionFocusBgColor: 'transparent',

			selectPlaceholderErrorColor: colors.coral,
			selectErrorBgColor: 'transparent',
			selectBorderErrorColor: colors.coral,
		},
	},

	account: {
		colors: {
			account_backgroundColor: colors.lightWhite,

			account_errorColor: colors.coral,
			account_errorColorBg: colors.pink,

			account_primaryColor1: colors.black,
			account_primaryColor2: colors.darkGrey,
			account_primaryColor3: colors.coral,
			account_primaryColor4: colors.black,
			account_primaryColor5: colors.grey,
			account_primaryColor14: colors.black,

			account_secondaryColor2: colors.coral,
			account_secondaryColor9: colors.coral,
			account_secondaryColor13: colors.coral,

			account_surfaceColor: colors.lightGreen,
		},
	},
};
